import { useState, useEffect } from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import { crearMrcvRegistro, editarMrcvRegistro } from "../api/mrcvAPI.js";
import { subirFotoVivienda, adjuntarFotoCarnet } from "../api/bacSarampionAPI.js";
import { obtenerCatalogosCacheados } from "../api/catalogosCache";
import { comprimirImagen, blobABase64 } from "../utils/imageCompression";
import API from "../../axios.jsx";

const selectStyles = {
  control: (base) => ({ ...base, minHeight: 38, fontSize: 16 }),
  menuPortal: (base) => ({ ...base, zIndex: 2000 }),
};
const opcionesSelect = (arr) => arr.map(v => ({ value: v, label: v }));
const valorSelect = (v) => (v ? { value: v, label: v } : null);

const VACUNAS = [
  { clave: "bcg",                      nombre: "BCG",                                grupo: "< 6 Meses" },
  { clave: "rotavirus2",               nombre: "Rotavirus 2",                        grupo: "< 12 Meses" },
  { clave: "neumococo2",               nombre: "Neumococo 2",                        grupo: "< 12 Meses" },
  { clave: "polio3",                   nombre: "Polio 3",                            grupo: "< 12 Meses" },
  { clave: "pentavalente3",            nombre: "Pentavalente 3",                     grupo: "< 12 Meses" },
  { clave: "neumococo_refuerzo",       nombre: "Neumococo refuerzo",                 grupo: "12-23 Meses" },
  { clave: "triple_viral_1",           nombre: "Triple viral 1ª dosis",              grupo: "12-23 Meses" },
  { clave: "fiebre_amarilla",          nombre: "Fiebre Amarilla",                    grupo: "12-23 Meses" },
  { clave: "triple_viral_refuerzo18",  nombre: "Triple viral refuerzo 18 meses",     grupo: "18-23 Meses" },
  { clave: "hepatitis_a",              nombre: "Hepatitis A",                        grupo: "12-23 Meses" },
  { clave: "triple_viral_2a5",         nombre: "Triple viral refuerzo 2-5 años",     grupo: "24-60 Meses" },
];

// Los 18 códigos oficiales — pregunta 40, "Motivos de no vacunación",
// agrupados en las 3 categorías del instrumento.
const MOTIVOS_NO_VACUNACION = [
  { grupo: "Relacionados con la logística y las estrategias del programa", opciones: [
    "Lugar de vacunación lejano o cerrado, ausencia del vacunador",
    "Horario de vacunación restringido",
    "Largos tiempos de espera",
    "No había vacunas o insumos",
    "Falta o pérdida de carné de vacunación",
    "No afiliado",
    "Desconocimiento de la jornada",
    "Desconocimiento que las vacunas son gratis",
  ]},
  { grupo: "Relacionados con la salud del usuario", opciones: [
    "Niño enfermo",
    "Niño hospitalizado",
    "Orden médica por enfermedad",
    "Reacción adversa a dosis previas (leve, moderada o grave)",
    "El médico dijo que tenía las vacunas completas",
    "Peso menor a 2000",
    "Anafilaxia a dosis previas (reacción alérgica grave que compromete la vida del niño)",
  ]},
  { grupo: "Relacionados con el cuidador o familia", opciones: [
    "Falta de tiempo del cuidador",
    "Rechazo de la vacunación",
    "Porque tiene las vacunas completas",
  ]},
];

// Las 8 opciones oficiales — pregunta 13, "Motivo No carné".
const MOTIVOS_NO_CARNET = [
  "No ha sido vacunado",
  "Se perdió",
  "Lo tiene la promotora o vacunadora de la zona",
  "Lo tiene familiar no disponible en el momento",
  "Lo tiene la EPS al que está afiliado",
  "Lo tiene la ESE o IPS que vacuna la zona",
  "Se encuentra en el hogar infantil del ICBF o jardín",
  "Lo tiene el programa familias en acción",
];

const VACIO = {
  nombre_nino: "", documento_nino: "", nombre_madre: "", documento_madre: "", telefono: "",
  regimen: "", aseguradora: "", condicion_desplazamiento: "NO", etnia: "",
  tiene_carnet: "SI", motivo_no_carnet: "", esquema_completo: "", motivo_no_vacunacion: "",
  fecha_encuesta: new Date().toISOString().split("T")[0], fecha_nacimiento: "",
};

export default function CrearMrcvModal({ show, onClose, viviendaBase, registroEditar, onGuardado, modoLocal = false, datosIniciales = null, fotoPreview = null, onGuardarLocal }) {
  const [form, setForm] = useState(VACIO);
  const [vacunas, setVacunas] = useState({});
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  const [catalogos, setCatalogos] = useState({});
  const [nuevaFotoA, setNuevaFotoA] = useState(null);
  const [nuevaFotoB, setNuevaFotoB] = useState(null);
  const [nuevaFotoPaiweb, setNuevaFotoPaiweb] = useState(null);
  const [comprimiendoCarnet, setComprimiendoCarnet] = useState(false);
  const opcionesDe = (tipo) => catalogos[tipo] || [];

  useEffect(() => {
    obtenerCatalogosCacheados().then(setCatalogos).catch(() => {});
  }, []);

  useEffect(() => {
    if (!show) return;
    if (registroEditar) {
      const limpio = { ...registroEditar };
      Object.keys(limpio).forEach(k => { if (limpio[k] === null) limpio[k] = ""; });
      setForm({ ...VACIO, ...limpio });
      const v = {};
      VACUNAS.forEach(({ clave }) => {
        v[clave] = { fecha: registroEditar[`${clave}_fecha`] || "", verificado: registroEditar[`${clave}_verificado`] || "" };
      });
      setVacunas(v);
    } else if (datosIniciales) {
      const limpio = { ...datosIniciales };
      Object.keys(limpio).forEach(k => { if (limpio[k] === null) limpio[k] = ""; });
      setForm({ ...VACIO, ...limpio });
      setVacunas({});
    } else {
      setForm(VACIO);
      setVacunas({});
    }
    setError("");
    setNuevaFotoA(null);
    setNuevaFotoB(null);
    setNuevaFotoPaiweb(null);
  }, [show, registroEditar, datosIniciales]);

  if (!show) return null;

  const set = (campo, valor) => setForm(p => ({ ...p, [campo]: valor }));
  const setVacuna = (clave, campo, valor) => setVacunas(p => ({ ...p, [clave]: { ...p[clave], [campo]: valor } }));

  const fotoUrl = modoLocal ? null : (registroEditar?.visita?.foto_url || viviendaBase?.foto_url);
  const codigoVivienda = registroEditar?.visita?.codigo_vivienda || viviendaBase?.codigo_vivienda;

  const handleFotoCarnet = async (e, lado) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setComprimiendoCarnet(true);
    try {
      const comprimida = await comprimirImagen(file, { maxAncho: 1280, calidad: 0.7 });
      const base64 = await blobABase64(comprimida);
      const datos = { base64, nombre: file.name };
      if (lado === "a") setNuevaFotoA(datos); else if (lado === "b") setNuevaFotoB(datos); else setNuevaFotoPaiweb(datos);
    } catch {
      setError("No se pudo procesar la foto");
    } finally {
      setComprimiendoCarnet(false);
    }
  };

  const guardar = async () => {
    if (!form.nombre_nino || !form.fecha_nacimiento || !form.fecha_encuesta) {
      setError("Nombre del niño/a, fecha de nacimiento y fecha de encuesta son obligatorios");
      return;
    }
    setError("");

    const payload = { ...form };
    VACUNAS.forEach(({ clave }) => {
      payload[`${clave}_fecha`] = vacunas[clave]?.fecha || null;
      payload[`${clave}_verificado`] = vacunas[clave]?.verificado || null;
    });

    // ── Modo local (dentro del wizard, la visita todavía no existe) —
    //    no llama al API, solo le entrega los datos al padre para que
    //    viajen juntos en el payload de la visita.
    if (modoLocal) {
      onGuardarLocal(payload);
      onClose();
      return;
    }

    setGuardando(true);
    try {
      payload.codigo_vivienda = codigoVivienda;
      if (registroEditar) {
        await editarMrcvRegistro(registroEditar.id, payload);
      } else {
        await crearMrcvRegistro(payload);
      }

      // Si se cambió alguna cara del carné, se sube y se liga al mismo
      // registro de pai_carnets que ya existía para esta persona (match
      // por documento) — no crea uno nuevo, actualiza el que ya está.
      let fotoFallo = false;
      if ((nuevaFotoA || nuevaFotoB || nuevaFotoPaiweb) && codigoVivienda && form.documento_nino) {
        try {
          for (const [lado, foto] of [["a", nuevaFotoA], ["b", nuevaFotoB], ["paiweb", nuevaFotoPaiweb]]) {
            if (!foto) continue;
            const fd = new FormData();
            fd.append("archivo", await (await fetch(foto.base64)).blob(), foto.nombre);
            const resSubida = await subirFotoVivienda(fd);
            await adjuntarFotoCarnet(codigoVivienda, form.documento_nino, lado, { foto_url: resSubida.data.url, foto_nombre: resSubida.data.nombre });
          }
        } catch {
          fotoFallo = true;
        }
      }

      if (fotoFallo) {
        Swal.fire({ icon: "warning", title: "MRCV guardado, pero la foto del carné no se pudo subir", text: "Intenta cambiarla de nuevo en un momento.", confirmButtonColor: "#16342a" });
      } else {
        Swal.fire({ icon: "success", title: "MRCV guardado", timer: 1600, showConfirmButton: false });
      }
      onGuardado();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || "No se pudo guardar — revisa tu conexión");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered scrollable size="lg">
      <Modal.Header closeButton style={{ background: "linear-gradient(135deg, #16342a, #2d6a4f)", color: "#fff" }}>
        <Modal.Title style={{ fontSize: "1rem" }}>📋 MRCV — {form.nombre_nino || codigoVivienda}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Foto heredada del barrido — no se vuelve a pedir */}
        {fotoUrl && (
          <div className="mb-3 text-center">
            <img src={`${API.defaults.baseURL}${fotoUrl}`} alt="Vivienda (del barrido)" style={{ maxWidth: "100%", maxHeight: 160, borderRadius: 8, border: "1px solid #dee2e6" }} />
            <div className="text-muted mt-1" style={{ fontSize: 10.5 }}>📷 Foto tomada durante el barrido — no hace falta repetirla</div>
          </div>
        )}
        {!modoLocal && registroEditar && (
          <div className="mb-3">
            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#16342a", background: "#eef1e7", borderRadius: 6, padding: "5px 11px", marginBottom: 8 }}>
              🪪 Carné tomado en el barrido
            </div>
            <div className="row g-2">
              {[
                { lado: "a", label: "Cara A", nueva: nuevaFotoA, url: registroEditar.carnet_foto_a_url },
                { lado: "b", label: "Cara B", nueva: nuevaFotoB, url: registroEditar.carnet_foto_b_url },
                { lado: "paiweb", label: "PAIWEB", nueva: nuevaFotoPaiweb, url: registroEditar.carnet_foto_paiweb_url },
              ].map(({ lado, label, nueva, url }) => (
                <div className="col-4" key={lado}>
                  <div className="d-flex align-items-center gap-2 p-2 rounded" style={{ background: "#fff", border: "1px dashed #dee2e6" }}>
                    <div className="rounded d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 50, height: 50, background: "#eef1e7", overflow: "hidden" }}>
                      {nueva ? <img src={nueva.base64} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        : url ? <img src={`${API.defaults.baseURL}${url}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        : "🪪"}
                    </div>
                    <div className="flex-grow-1">
                      <div style={{ fontSize: 10.5, fontWeight: 700, marginBottom: 2 }}>{label}</div>
                      <label className="btn btn-outline-secondary btn-sm mb-0" style={{ fontSize: 10.5 }}>
                        {comprimiendoCarnet ? "Procesando…" : (nueva || url) ? "Cambiar foto" : "Agregar foto"}
                        <input type="file" accept="image/*" onChange={e => handleFotoCarnet(e, lado)} disabled={comprimiendoCarnet} className="d-none" />
                      </label>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {modoLocal && fotoPreview && (
          <div className="mb-3 text-center d-flex justify-content-center gap-2">
            {fotoPreview.fotoA && <img src={fotoPreview.fotoA} alt="Carné cara A" style={{ maxHeight: 110, borderRadius: 8, border: "1px solid #dee2e6" }} />}
            {fotoPreview.fotoB && <img src={fotoPreview.fotoB} alt="Carné cara B" style={{ maxHeight: 110, borderRadius: 8, border: "1px solid #dee2e6" }} />}
          </div>
        )}
        {modoLocal && (
          <div className="alert alert-info py-2 px-3 mb-3" style={{ fontSize: 11.5 }}>
            ℹ️ Esto se guarda junto con la visita — no se envía al servidor todavía por separado.
          </div>
        )}

        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#16342a", background: "#eef1e7", borderRadius: 6, padding: "5px 11px", marginBottom: 8 }}>
          🧒 Identificación del niño/a
        </div>
        <div className="row g-2 mb-2">
          <div className="col-12 col-md-6">
            <Form.Label style={{ fontSize: 11 }}>Nombre completo *</Form.Label>
            <Form.Control size="sm" value={form.nombre_nino} onChange={e => set("nombre_nino", e.target.value)} />
          </div>
          <div className="col-12 col-md-6">
            <Form.Label style={{ fontSize: 11 }}>N° de identificación</Form.Label>
            <Form.Control size="sm" value={form.documento_nino} onChange={e => set("documento_nino", e.target.value)} />
          </div>
          <div className="col-6 col-md-6">
            <Form.Label style={{ fontSize: 11 }}>Fecha de nacimiento *</Form.Label>
            <Form.Control size="sm" type="date" max={new Date().toISOString().split("T")[0]} value={form.fecha_nacimiento} onChange={e => set("fecha_nacimiento", e.target.value)} />
          </div>
          <div className="col-6 col-md-6">
            <Form.Label style={{ fontSize: 11 }}>Fecha de encuesta *</Form.Label>
            <Form.Control size="sm" type="date" value={form.fecha_encuesta} onChange={e => set("fecha_encuesta", e.target.value)} />
          </div>
        </div>

        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#16342a", background: "#eef1e7", borderRadius: 6, padding: "5px 11px", marginBottom: 8, marginTop: 12 }}>
          👩 Madre / acudiente
        </div>
        <div className="row g-2 mb-2">
          <div className="col-12 col-md-6">
            <Form.Label style={{ fontSize: 11 }}>Nombre completo de la madre</Form.Label>
            <Form.Control size="sm" value={form.nombre_madre} onChange={e => set("nombre_madre", e.target.value)} />
          </div>
          <div className="col-6 col-md-3">
            <Form.Label style={{ fontSize: 11 }}>N° de identificación</Form.Label>
            <Form.Control size="sm" value={form.documento_madre} onChange={e => set("documento_madre", e.target.value)} />
          </div>
          <div className="col-6 col-md-3">
            <Form.Label style={{ fontSize: 11 }}>Teléfono</Form.Label>
            <Form.Control size="sm" value={form.telefono} onChange={e => set("telefono", e.target.value)} />
          </div>
        </div>

        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#16342a", background: "#eef1e7", borderRadius: 6, padding: "5px 11px", marginBottom: 8, marginTop: 12 }}>
          🏥 Afiliación y enfoque
        </div>
        <div className="row g-2 mb-2">
          <div className="col-6 col-md-3">
            <Form.Label style={{ fontSize: 11 }}>Régimen</Form.Label>
            <Form.Select size="sm" value={form.regimen} onChange={e => set("regimen", e.target.value)}>
              <option value="">Selecciona...</option>
              {opcionesDe("regimenes-afiliacion").map(v => <option key={v} value={v}>{v}</option>)}
            </Form.Select>
          </div>
          <div className="col-6 col-md-3">
            <Form.Label style={{ fontSize: 11 }}>Aseguradora (EPS)</Form.Label>
            <Select
              placeholder="Buscar EPS..."
              options={opcionesSelect(opcionesDe("eps"))}
              value={valorSelect(form.aseguradora)}
              onChange={(sel) => set("aseguradora", sel?.value || "")}
              isClearable menuPlacement="auto" menuPosition="fixed"
              styles={selectStyles}
            />
          </div>
          <div className="col-6 col-md-3">
            <Form.Label style={{ fontSize: 11 }}>Etnia</Form.Label>
            <Select
              placeholder="Buscar etnia..."
              options={opcionesSelect(opcionesDe("etnias"))}
              value={valorSelect(form.etnia)}
              onChange={(sel) => set("etnia", sel?.value || "")}
              isClearable menuPlacement="auto" menuPosition="fixed"
              styles={selectStyles}
            />
          </div>
          <div className="col-6 col-md-3">
            <Form.Label style={{ fontSize: 11 }}>¿Condición de desplazamiento?</Form.Label>
            <div className="d-flex gap-1">
              {["SI", "NO"].map(v => (
                <Button key={v} type="button" size="sm" className="flex-grow-1"
                  variant={form.condicion_desplazamiento === v ? (v === "SI" ? "warning" : "outline-secondary") : "outline-secondary"}
                  onClick={() => set("condicion_desplazamiento", v)}>{v}</Button>
              ))}
            </div>
          </div>
        </div>

        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#16342a", background: "#eef1e7", borderRadius: 6, padding: "5px 11px", marginBottom: 8, marginTop: 12 }}>
          🪪 Carné
        </div>
        <div className="d-flex gap-2 mb-2">
          {["SI", "NO"].map(v => (
            <Button key={v} type="button" size="sm" className="flex-grow-1"
              variant={form.tiene_carnet === v ? (v === "SI" ? "success" : "danger") : "outline-secondary"}
              onClick={() => set("tiene_carnet", v)}>{v}</Button>
          ))}
        </div>
        {form.tiene_carnet === "NO" && (
          <Form.Select size="sm" className="mb-2" value={form.motivo_no_carnet} onChange={e => set("motivo_no_carnet", e.target.value)}>
            <option value="">Selecciona el motivo...</option>
            {MOTIVOS_NO_CARNET.map((m, i) => <option key={m} value={m}>{i + 1}. {m}</option>)}
          </Form.Select>
        )}

        {form.tiene_carnet === "SI" && (
          <>
            <Form.Label style={{ fontSize: 11 }}>¿Esquema completo?</Form.Label>
            <div className="d-flex gap-2 mb-2">
              {["Si", "No"].map(v => (
                <Button key={v} type="button" size="sm" className="flex-grow-1"
                  variant={form.esquema_completo === v ? (v === "Si" ? "success" : "warning") : "outline-secondary"}
                  onClick={() => set("esquema_completo", v)}>{v}</Button>
              ))}
            </div>
            {form.esquema_completo === "No" && (
              <>
                <Form.Label style={{ fontSize: 11 }}>Motivo de no vacunación</Form.Label>
                <Form.Select size="sm" className="mb-2" value={form.motivo_no_vacunacion} onChange={e => set("motivo_no_vacunacion", e.target.value)}>
                  <option value="">Selecciona el motivo...</option>
                  {MOTIVOS_NO_VACUNACION.map(({ grupo, opciones }) => (
                    <optgroup key={grupo} label={grupo}>
                      {opciones.map(m => <option key={m} value={m}>{m}</option>)}
                    </optgroup>
                  ))}
                </Form.Select>
              </>
            )}

            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#16342a", background: "#eef1e7", borderRadius: 6, padding: "5px 11px", marginBottom: 8, marginTop: 12 }}>
              💉 Esquema — fecha de aplicación (según carné) y verificación en PAIWEB
            </div>
            {VACUNAS.map(({ clave, nombre, grupo }) => (
              <div key={clave} className="row g-2 align-items-end mb-2 pb-2" style={{ borderBottom: "1px solid #f1f3f5" }}>
                <div className="col-12 col-md-5">
                  <div style={{ fontSize: 12, fontWeight: 700 }}>{nombre}</div>
                  <div style={{ fontSize: 10, color: "#8a94a6" }}>{grupo}</div>
                </div>
                <div className="col-7 col-md-4">
                  <Form.Label style={{ fontSize: 10 }}>Fecha de aplicación</Form.Label>
                  <Form.Control size="sm" type="date" max={new Date().toISOString().split("T")[0]}
                    value={vacunas[clave]?.fecha || ""} onChange={e => setVacuna(clave, "fecha", e.target.value)} />
                </div>
                <div className="col-5 col-md-3">
                  <Form.Label style={{ fontSize: 10 }}>Verificado PAIWEB</Form.Label>
                  <Form.Select size="sm" value={vacunas[clave]?.verificado || ""} onChange={e => setVacuna(clave, "verificado", e.target.value)}>
                    <option value="">—</option>
                    <option value="SI">SI</option>
                    <option value="NO">NO</option>
                  </Form.Select>
                </div>
              </div>
            ))}
          </>
        )}

        {error && <Alert variant="danger" className="py-2 mt-2" style={{ fontSize: 12.5 }}>{error}</Alert>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>Cancelar</Button>
        <Button variant="success" onClick={guardar} disabled={guardando} style={{ background: "#16342a", border: "none" }}>
          {guardando ? "Guardando..." : "Guardar MRCV"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}